import { ScrollbarProps } from 'react-scrollbars-custom';
import React, { forwardRef } from 'react';

// react-scrollbars-custom is incompatible with React 18 Strict Mode
// Using native scrolling with styled div instead
const Scrollbar = forwardRef<
  HTMLDivElement,
  ScrollbarProps & { children?: React.ReactNode }
>(({ children, style, className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={className}
      style={{
        overflow: 'auto',
        height: '100%',
        width: '100%',
        WebkitOverflowScrolling: 'touch', // Smooth scrolling on iOS
        ...style,
      }}
    >
      {children}
    </div>
  );
});

Scrollbar.displayName = 'Scrollbar';

export default Scrollbar;
